import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { CaseQueue } from 'dashboard/models/case-queue';
import { CaseQueuesFilterParams, setCaseQueues } from 'dashboard/redux/slices/case-queues';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadCaseQueuesList({
  currentPage,
  pageSize,
  sortParams,
  filters: { status },
}: {
  currentPage?: number;
  pageSize?: number;
  sortParams?: SortParams;
  filters: CaseQueuesFilterParams;
}) {
  const options = {
    filter: {
      status,
    },
    page: {
      number: currentPage,
      size: pageSize,
    },
    ...(sortParams
      ? {
          sort: `${sortParams.shouldSortDescending ? '-' : ''}${sortParams.sort}`,
        }
      : {}),
  };

  return async (dispatch: Dispatch) => {
    const caseQueuesResponse = await SessionClientDashboard.listResource<
      CaseQueue,
      PaginationParams & { 'at-active-case-queue-limit': boolean }
    >(ApiEndpoint.CaseQueue, options);

    dispatch(
      setCaseQueues({
        caseQueues: caseQueuesResponse.data,
        atActiveCaseQueueLimit: !!caseQueuesResponse.meta?.['at-active-case-queue-limit'],
        paginationParams: caseQueuesResponse.meta,
      }),
    );
  };
}
